import { render, staticRenderFns } from "./EncuestaSISA.vue?vue&type=template&id=85ea7674&scoped=true&"
import script from "./EncuestaSISA.vue?vue&type=script&lang=js&"
export * from "./EncuestaSISA.vue?vue&type=script&lang=js&"
import style0 from "./EncuestaSISA.vue?vue&type=style&index=0&id=85ea7674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ea7674",
  null
  
)

export default component.exports